import React from 'react'
import { useTranslation } from 'react-i18next'
import Icon, { type IconName } from '@/components/common/Icon'

interface NavMenuButtonProps {
  textKey: string
  iconName: IconName
  isActive: boolean
  onClick: () => void
  dataTestId?: string
}

const NavMenuButton: React.FC<NavMenuButtonProps> = ({
  textKey,
  iconName,
  isActive,
  onClick,
  dataTestId,
}: NavMenuButtonProps) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={dataTestId}
      className={`rounded ${isActive ? 'bg-blue-800' : 'hover:bg-zinc-800'} flex h-8 items-center gap-1 px-4 text-sm font-semibold text-white`}
    >
      <Icon name={iconName} height={20} width={20} />
      <span>{t(textKey)}</span>
    </button>
  )
}

export default React.memo(NavMenuButton)
